import { camelizeKeys } from '@/helpers/object'

function transformVariant(country, item) {
  return variant => ({
    ...variant,
    spreeProduct: {
      ...variant.spreeProduct,
      groupName: item.productGroupName,
    },
    skus: [
      {
        stock: item.storesInformation[country]?.stock,
      },
    ],
  })
}

export function transformProduct(country, language) {
  return (product, index) => {
    const item = camelizeKeys(product)
    return {
      ...item,
      index,
      id: item.objectID,
      displayedVariantId: item.variantId,
      currentVariantId: item.variantId,
      name: item.productGroupName,
      productData: {
        shortDescription: item.translatedFields[language]?.productShortDescription || '',
      },
      price: item.storesInformation[country]?.price,
      variants: item.variantsInformation.map(transformVariant(country, item)),
    }
  }
}

export function transformPromoCard(language) {
  return (promoCard, index) => {
    const item = camelizeKeys({ ...promoCard, index })
    return {
      ...item,
      cardIndex: index,
      index,
      ctaText: item.translatedFields[language].ctaText,
      text: item.translatedFields[language].text,
    }
  }
}
